(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-tabs"] && !Shopify.designMode) return;
  try {
    
  class ImageTabsSection extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('[data-image-tabs-nav]');
      this.dots = this.querySelector('[data-image-tabs-dots]');
      this.panels = Array.from(this.querySelectorAll('[data-image-tabs-panel]'));
      this.buildNavigation();
      this.buttons = Array.from(this.querySelectorAll('[data-image-tabs-button]'));
      this.dotButtons = Array.from(this.querySelectorAll('[data-image-tabs-dot]'));
      this.currentIndex = 0;
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.activate(button.dataset.imageTabsButton, { scrollNav: true }));
        if (index === 0) {
          this.currentIndex = 0;
        }
      });
      this.dotButtons.forEach((dot) => {
        dot.addEventListener('click', () => this.activate(dot.dataset.imageTabsDot, { scrollNav: true }));
      });
      this.nav?.addEventListener('scroll', this.onNavScroll.bind(this), { passive: true });
      this.bindSwipe();
      if (this.buttons.length) {
        this.activate(this.buttons[0].dataset.imageTabsButton, { scrollNav: false });
      }
    }

    disconnectedCallback() {
      this.unbindSwipe();
    }

    buildNavigation() {
      if (!this.nav || !this.panels.length) return;
      this.nav.replaceChildren();
      this.dots?.replaceChildren();
      this.panels.forEach((panel, index) => {
        const id = panel.dataset.imageTabsPanel;
        const title = panel.dataset.imageTabsTitle || `Tab ${index + 1}`;
        const button = document.createElement('button');
        button.className = 'image-tabs-root__button';
        button.type = 'button';
        button.role = 'tab';
        button.id = `image-tab-${id}`;
        button.setAttribute('aria-controls', `image-panel-${id}`);
        button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        button.tabIndex = index === 0 ? 0 : -1;
        button.dataset.imageTabsButton = id;
        button.textContent = title;
        panel.setAttribute('aria-labelledby', button.id);
        this.nav.append(button);

        const dot = document.createElement('button');
        dot.className = 'image-tabs-root__dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', title);
        dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        dot.dataset.imageTabsDot = id;
        this.dots?.append(dot);
      });
    }

    bindSwipe() {
      if (this.swipeBound || !this.panels.length) return;
      this.swipeBound = true;
      this.pointerStart = null;
      this.onPointerDown = (event) => {
        if (event.pointerType === 'mouse' || event.isPrimary === false) return;
        if (event.target.closest('[data-image-tabs-button], [data-image-tabs-dot]')) return;
        this.pointerStart = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          time: Date.now(),
        };
      };
      this.onPointerUp = (event) => {
        if (!this.pointerStart || event.pointerId !== this.pointerStart.id) return;
        const deltaX = event.clientX - this.pointerStart.x;
        const deltaY = event.clientY - this.pointerStart.y;
        const elapsed = Date.now() - this.pointerStart.time;
        this.pointerStart = null;
        if (Math.abs(deltaX) < 30 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2 || elapsed > 900) return;
        this.activateByOffset(deltaX < 0 ? 1 : -1);
      };
      this.onPointerCancel = () => {
        this.pointerStart = null;
      };
      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('pointerup', this.onPointerUp);
      this.addEventListener('pointercancel', this.onPointerCancel);
    }

    unbindSwipe() {
      if (!this.swipeBound) return;
      this.removeEventListener('pointerdown', this.onPointerDown);
      this.removeEventListener('pointerup', this.onPointerUp);
      this.removeEventListener('pointercancel', this.onPointerCancel);
      this.swipeBound = false;
    }

    activateByOffset(offset) {
      if (!this.buttons.length) return;
      const nextIndex = Math.max(0, Math.min(this.currentIndex + offset, this.buttons.length - 1));
      const nextButton = this.buttons[nextIndex];
      if (nextButton) {
        this.activate(nextButton.dataset.imageTabsButton, { scrollNav: true });
      }
    }

    onNavScroll() {
      if (!this.nav || !this.buttons?.length || this.isScrollingNavIntoView) return;
      window.clearTimeout(this.scrollTimeout);
      this.scrollTimeout = window.setTimeout(() => {
        const index = Math.round(this.nav.scrollLeft / this.nav.clientWidth);
        const button = this.buttons[Math.max(0, Math.min(index, this.buttons.length - 1))];
        if (button) this.activate(button.dataset.imageTabsButton, { scrollNav: false });
      }, 80);
    }

    activate(id, options = {}) {
      const update = () => {
        this.buttons.forEach((button, index) => {
          const active = button.dataset.imageTabsButton === id;
          button.setAttribute('aria-selected', active ? 'true' : 'false');
          button.tabIndex = active ? 0 : -1;
          if (active) {
            this.currentIndex = index;
            if (options.scrollNav) {
              this.isScrollingNavIntoView = true;
              button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
              window.clearTimeout(this.navScrollResetTimeout);
              this.navScrollResetTimeout = window.setTimeout(() => {
                this.isScrollingNavIntoView = false;
              }, 450);
            }
          }
        });
        this.dotButtons?.forEach((dot) => {
          dot.setAttribute('aria-current', dot.dataset.imageTabsDot === id ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          const active = panel.dataset.imageTabsPanel === id;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      if (document.startViewTransition && !options.scrollNav) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }
  }

  if (!customElements.get('image-tabs-section')) {
    customElements.define('image-tabs-section', ImageTabsSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-cards"] && !Shopify.designMode) return;
  try {
    
  class LifestyleCards extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.lifestyle-cards__viewport');
      this.track = this.querySelector('.lifestyle-cards__track');
      this.previousButton = this.querySelector('.lifestyle-cards__arrow--prev');
      this.nextButton = this.querySelector('.lifestyle-cards__arrow--next');
      this.cards = Array.from(this.querySelectorAll('.lifestyle-card'));

      this.cards.forEach((card) => {
        card.addEventListener('toggle', () => {
          if (!card.open) return;
          this.cards.forEach((otherCard) => {
            if (otherCard !== card) otherCard.removeAttribute('open');
          });
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        });
      });

      this.previousButton?.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
    }

    scrollByCard(direction) {
      const card = this.cards[0];
      if (!card || !this.viewport) return;
      const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
      this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
  }

  if (!customElements.get('lifestyle-cards')) {
    customElements.define('lifestyle-cards', LifestyleCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-items"] && !Shopify.designMode) return;
  try {
    
  class ProductPageItems extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-ppi-dialog]');
      this.dialogMedia = this.querySelector('[data-ppi-dialog-media]');
      this.dialogHeader = this.querySelector('[data-ppi-dialog-header]');
      this.dialogHeaderTitle = this.querySelector('[data-ppi-dialog-header-title]');
      this.closeButton = this.querySelector('[data-ppi-dialog-close]');
      this.fixedPurchaseCards = Array.from(this.querySelectorAll('.product-page-items__fixed-purchase'));
      this.fixedPurchaseShrinkOffset = 24;
      this.lastFixedPurchaseScrollY = window.scrollY;
      this.fixedPurchaseScrollDirection = 'up';
      this.boundUpdateFixedPurchase = () => this.updateFixedPurchaseVisibility();

      this.setupCardVideos();
      this.setupFixedPurchaseGuard();

      this.querySelectorAll('[data-ppi-open-media]').forEach((card) => {
        card.addEventListener('click', () => {
          const template = card.querySelector('template');
          if (!template || !this.dialog || !this.dialogMedia) return;
          this.dialogMedia.replaceChildren(template.content.cloneNode(true));
          this.dialog.showModal();
          this.openFullscreen();
          this.syncGalleryHeader();
          this.setupGallery();
          const video = this.dialogMedia.querySelector('video');
          if (video) video.play().catch(() => {});
        });
      });

      this.querySelectorAll('[data-ppi-page-link]').forEach((card) => {
        card.addEventListener('click', () => {
          const targetKey = card.dataset.ppiPageLink;
          if (!targetKey) return;
          const targetPage = this.querySelector(`[data-ppi-page-key="${CSS.escape(targetKey)}"]`);
          if (!targetPage) return;
          targetPage.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.closeDialog());
      }
      if (this.dialog) {
        this.dialog.addEventListener('click', (event) => {
          const closeTrigger = event.target.closest('[data-ppi-dialog-close]');
          if (closeTrigger) {
            event.preventDefault();
            event.stopPropagation();
            this.closeDialog();
            return;
          }
          if (event.target === this.dialog) this.closeDialog();
        });
      }
      if (this.dialogMedia) {
        this.dialogMedia.addEventListener('click', (event) => {
          const closeTrigger = event.target.closest('[data-ppi-dialog-close]');
          if (!closeTrigger) return;
          event.preventDefault();
          event.stopPropagation();
          this.closeDialog();
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.boundUpdateFixedPurchase);
      window.removeEventListener('resize', this.boundUpdateFixedPurchase);
    }

    setupFixedPurchaseGuard() {
      if (!this.fixedPurchaseCards.length) return;
      window.addEventListener('scroll', this.boundUpdateFixedPurchase, { passive: true });
      window.addEventListener('resize', this.boundUpdateFixedPurchase);
      this.updateFixedPurchaseVisibility();
    }

    updateFixedPurchaseVisibility() {
      if (!this.fixedPurchaseCards.length) return;

      const currentScrollY = window.scrollY;
      const scrollDelta = currentScrollY - this.lastFixedPurchaseScrollY;

      if (Math.abs(scrollDelta) > 2) {
        this.fixedPurchaseScrollDirection = scrollDelta > 0 ? 'down' : 'up';
        this.lastFixedPurchaseScrollY = currentScrollY;
      }

      const section = this.closest('.shopify-section') || this;
      const sectionRect = section.getBoundingClientRect();
      const shouldShrink = currentScrollY > this.fixedPurchaseShrinkOffset && this.fixedPurchaseScrollDirection === 'down';

      this.fixedPurchaseCards.forEach((card) => {
        const computedStyle = window.getComputedStyle(card);
        const bottomOffset = parseFloat(computedStyle.bottom) || 0;
        const cardHeight = card.offsetHeight;
        const fixedCardTop = window.innerHeight - bottomOffset - cardHeight;
        const isPinnedToSectionEnd = fixedCardTop >= sectionRect.bottom - 15 - cardHeight;

        card.classList.toggle('is-pinned-to-section-end', isPinnedToSectionEnd);
        card.classList.toggle('is-scrolled', shouldShrink && !isPinnedToSectionEnd);
      });
    }

    setupCardVideos() {
      this.querySelectorAll('[data-ppi-card-video]').forEach((video) => {
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.autoplay = true;
        video.controls = false;

        const durationBadge = video.closest('.product-page-item-grid-card')?.querySelector('[data-ppi-video-duration]');
        const updateDuration = () => {
          if (!durationBadge || !Number.isFinite(video.duration) || video.duration <= 0) return;
          const minutes = Math.floor(video.duration / 60);
          const seconds = Math.floor(video.duration % 60).toString().padStart(2, '0');
          durationBadge.textContent = `${minutes}:${seconds}`;
        };

        video.addEventListener('loadedmetadata', updateDuration);
        updateDuration();

        const playVideo = () => video.play().catch(() => {});
        if (video.readyState >= 2) {
          playVideo();
        } else {
          video.addEventListener('canplay', playVideo, { once: true });
        }
      });
    }

    openFullscreen() {
      if (!this.dialog) return;
      const requestFullscreen = this.dialog.requestFullscreen || this.dialog.webkitRequestFullscreen;
      if (requestFullscreen) {
        requestFullscreen.call(this.dialog).catch(() => {});
      }
    }

    setupGallery() {
      const gallery = this.dialogMedia?.querySelector('[data-ppi-gallery]');
      if (!gallery) return;

      const items = Array.from(gallery.querySelectorAll('.product-page-items__gallery-item'));
      if (!items.length) return;

      const track = document.createElement('div');
      track.className = 'product-page-items__gallery-track';
      items.forEach((item) => track.appendChild(item));
      gallery.replaceChildren(track);

      const dots = this.dialogMedia.querySelector('[data-ppi-gallery-dots]');
      let currentIndex = 0;

      const render = () => {
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
        if (dots) {
          Array.from(dots.children).forEach((dot, index) => {
            dot.classList.toggle('is-active', index === currentIndex);
          });
        }
      };

      const goTo = (index) => {
        currentIndex = (index + items.length) % items.length;
        render();
      };

      if (dots) {
        dots.replaceChildren();
        items.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Go to image ${index + 1}`);
          dot.addEventListener('click', () => goTo(index));
          dots.appendChild(dot);
        });
      }

      const prevButton = this.dialog?.querySelector('[data-ppi-gallery-prev]');
      const nextButton = this.dialog?.querySelector('[data-ppi-gallery-next]');
      prevButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        goTo(currentIndex - 1);
      });
      nextButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        goTo(currentIndex + 1);
      });

      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerCurrentX = 0;
      let isPointerDragging = false;
      let isHorizontalSwipe = false;

      const resetPointerState = () => {
        pointerStartX = 0;
        pointerStartY = 0;
        pointerCurrentX = 0;
        isPointerDragging = false;
        isHorizontalSwipe = false;
        track.style.transition = '';
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
      };

      gallery.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        pointerCurrentX = event.clientX;
        isPointerDragging = true;
        isHorizontalSwipe = false;
        track.style.transition = 'none';
      });

      gallery.addEventListener('pointermove', (event) => {
        if (!isPointerDragging) return;

        const deltaX = event.clientX - pointerStartX;
        const deltaY = event.clientY - pointerStartY;

        if (!isHorizontalSwipe && Math.abs(deltaX) > 8) {
          isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY) * 1.2;
        }

        if (!isHorizontalSwipe) return;

        event.preventDefault();
        pointerCurrentX = event.clientX;
        const dragPercent = (deltaX / gallery.clientWidth) * 100;
        track.style.transform = `translateX(${-(currentIndex * 100) + dragPercent}%)`;
      });

      const endPointerSwipe = () => {
        if (!isPointerDragging) return;

        const deltaX = pointerCurrentX - pointerStartX;
        const threshold = Math.min(90, gallery.clientWidth * 0.18);
        track.style.transition = '';

        if (isHorizontalSwipe && Math.abs(deltaX) > threshold) {
          goTo(currentIndex + (deltaX < 0 ? 1 : -1));
        } else {
          render();
        }

        resetPointerState();
      };

      gallery.addEventListener('pointerup', endPointerSwipe);
      gallery.addEventListener('pointercancel', resetPointerState);
      gallery.addEventListener('lostpointercapture', endPointerSwipe);

      const prevZone = document.createElement('button');
      prevZone.type = 'button';
      prevZone.className = 'product-page-items__gallery-click-zone product-page-items__gallery-click-zone--prev';
      prevZone.setAttribute('aria-label', 'Previous image');
      prevZone.addEventListener('click', () => goTo(currentIndex - 1));

      const nextZone = document.createElement('button');
      nextZone.type = 'button';
      nextZone.className = 'product-page-items__gallery-click-zone product-page-items__gallery-click-zone--next';
      nextZone.setAttribute('aria-label', 'Next image');
      nextZone.addEventListener('click', () => goTo(currentIndex + 1));

      gallery.append(prevZone, nextZone);
      render();
    }

    syncGalleryHeader() {
      if (!this.dialogHeader) return;
      const galleryScene = this.dialogMedia?.querySelector('.product-page-items__modal-scene--gallery');
      if (!galleryScene) {
        this.dialogHeader.hidden = true;
        return;
      }

      this.dialogHeader.removeAttribute('style');
      this.dialogHeader.style.cssText = galleryScene.getAttribute('style') || '';
      if (this.dialogHeaderTitle) {
        this.dialogHeaderTitle.textContent = galleryScene.dataset.ppiGalleryTitle || 'Gallery';
      }
      this.dialogHeader.hidden = false;
    }

    closeDialog() {
      if (!this.dialog) return;
      if (document.fullscreenElement && document.exitFullscreen) {
        document.exitFullscreen().catch(() => {});
      } else if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
      if (this.dialog.open) this.dialog.close();
      if (this.dialogHeader) {
        this.dialogHeader.hidden = true;
        this.dialogHeader.removeAttribute('style');
      }
      if (this.dialogMedia) {
        this.dialogMedia.replaceChildren();
      }
    }
  }

  if (!customElements.get('product-page-items')) {
    customElements.define('product-page-items', ProductPageItems);
  }

  } catch(e) { console.error(e); }
})();
})();
